import {
  initialise as initialiseGoogleTracking,
  trackEvent as trackGoogleEvent,
  trackPage as trackGooglePage,
} from 'helpers/tracking/googleAnalytics'

import {trackPage as trackHubspotPage} from 'helpers/tracking/hubspot'

export const getTrackingId = (trackingIds, defaultTrackingId) => {
  const href = window.location.href
  return getTrackingIdForHref(href, trackingIds, defaultTrackingId)
}

export const getTrackingIdForHref = (href, trackingIds, defaultTrackingId) => {
  const ret = trackingIds.find(tid => !!href.match(tid.match))

  return ret
      ? ret.id
      : defaultTrackingId
}

let isHubspotTrackingEnabled = false

export const initialiseTracking = (enableHubspotTracking) => {
  isHubspotTrackingEnabled = enableHubspotTracking

  initialiseGoogleTracking()

  trackInitialPage()
}

const trackInitialPage = () => {
  const {location} = window
  trackPageView(location)
}

export const trackPageView = (location) => {
  const {pathname} = location
  const path = getPagePathForTracking(pathname)

  trackGooglePage(path)

  if (isHubspotTrackingEnabled)
    trackHubspotPage(path)
}

export const trackEvent = (category, action, label) => {
  trackGoogleEvent(category, action, label)
}

export const getPagePathForTracking = (path) => {
  return path.replace(/(\/[0-9]+)/g, '/###')
}
